import { gql } from "@apollo/client";

export const UPDATE_MEMBER_EMAIL = gql`
  mutation($memberId: ID!, $email: String) {
    updateMemberEmail(memberId: $memberId, email: $email)
  }
`;
